import axios from 'axios';

const services = axios.create({
  baseURL: process.env.REACT_APP_SERVICES_API_URL,
});

export default services;
